import React, { useEffect, useState, useRef, useContext } from 'react';
import { CheckSession, RemoveCookie, GetCoockie, ValidateQty, days, user_session_id, shopping_cart_session_id, GetShoppingCart, UpdateShoppingCart } from "../GlobalScript";
import { ShoppingCartContext } from './ShoppingCartContext';
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import Cookies from 'js-cookie';
import useLocalStorage from './useLocalStorage';
import OrderSessionPopup from './OrderSessionPopup.js';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import CloseButton from 'react-bootstrap/CloseButton';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import ItemInquiry from './ItemInquiry.js';
import FooterDealer from '../FooterDealer.js';
import { useTranslation } from 'react-i18next';

export default function KCountriesHome() {
    const navigate = useNavigate();
    const [UserInfo, setUserInfo] = useState(null);
    const [itemNum, setItemNum] = useState('');
    const [quantity, setQuantity] = useState('');
    const [ItemsToitemInquiry, setItemsToitemInquiry] = useState([]);
    const [showItemModal, setShowItemModal] = useState(false);
    const [OpenOrderCount, setOpenOrderCount] = useState(null);
    const [BackOrderCount, setBackOrderCount] = useState(null);
    const [OpenCreditCount, setOpenCreditCount] = useState(null);
    const [showCartModal, setShowCartModal] = useState(false);
    const { shoppingCart, setShoppingCart, setCategoriesOpen } = useContext(ShoppingCartContext);
    const [vehicle, setVehicle] = useState('');
    const [model, setModel] = useState('');
    const [year, setYear] = useState('');
    const [ModelList, setModelList] = useState(null);
    const [YearList, setYearList] = useState(null);
    const [VehicleList, setVehicleList] = useState(null);
    const [pop, setPop] = useState(false);
    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);
    const { t } = useTranslation();

    useEffect(() => {
        document.title = 'K-Countries - Shop';
    }, []);

    const handleItemModalShow = (single) => {
        const crrMap = new Map();
        if (single === true) {
            const qty = ValidateQty(quantity);
            if (itemNum !== '' && qty !== '') {
                crrMap.set(itemNum, { sku: itemNum, qty: qty });
            }
        }
        setItemsToitemInquiry(Array.from(crrMap.values()));
        setShowItemModal(true);
    }

    const handleItemModalClose = () => setShowItemModal(false);
    const handleShowCartClose = () => setShowCartModal(false);
    const handleShowCartOpen = () => setShowCartModal(true);

    const handleSelectedItems = async (items) => {
        UpdateShoppingCart(items, setShoppingCart);
        navigate('/neworder');
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'itemNum') {
            setItemNum(value);
        } else if (name === 'quantity') {
            let newQty = ValidateQty(value);
            setQuantity(newQty);
            console.log(quantity);
        }
        else if (name === 'vehicle') {
            setVehicle(value);
        }
        else if (name === 'model') {
            setModel(value);
        }
        else if (name === 'year') {
            setYear(value);
        }
    }

    const handleOrderClicked = async () => {
        if (localStorage.getItem(shopping_cart_session_id)) {
            handleShowCartOpen();
        } else {
            navigate("/neworder");
        }
    }

    useEffect(() => {
        CheckSession();
        if (!UserInfo) {
            let ck = GetCoockie();
            setUserInfo(ck);
            window.GlobalLoading++;
        }
        if (window.GlobalLoading === 1) {
            window.location.reload();
        }
        setShoppingCart(GetShoppingCart(shoppingCart));
    }, [UserInfo])

    const LogoutDealerClick = () => {
        RemoveCookie(days, user_session_id);
        window.location.href = '/login';
        setUserInfo(null);
    }

    const LoadOrderCount = async (id) => {
        try {
            const response = await fetch("kdealer/GetOrderCount/" + id);
            if (response.status !== 200) {
                return;
            }
            const cnt = await response.json();
            if (cnt) {
                setOpenOrderCount(cnt.open_order);
                setBackOrderCount(cnt.back_order);
                setOpenCreditCount(cnt.open_credit_request);
            }
        }
        catch (e) {
            console.log(e);
            return;
        }
    }

    useEffect(() => {
        let ck = GetCoockie();
        if (ck) {
            LoadOrderCount(ck.dealerID);
        }
    }, [OpenOrderCount, BackOrderCount, OpenCreditCount])

    const searchVehicle = () => {
        if (!vehicle || !model || !year) {
            return;
        }
        navigate('/catalog', { state: { vehicle: vehicle, model: model, year: year } });
    }

    useEffect(() => {
        if (!VehicleList) {
            LoadVehicleList();
        }
    }, [VehicleList]);

    useEffect(() => {
        if (vehicle) {
            LoadYearList();
        }
        else {
            setYearList(null);
        }
        setModelList(null);
        setYear('');
        setModel('');
    }, [vehicle]);

    useEffect(() => {
        if (year) {
            LoadModelList();
        }
        else {
            setModelList(null);
        }
        setModel('');
    }, [year]);

    const LoadVehicleList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch("catalog/GetVehicleList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setVehicleList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const LoadYearList = async () => {
        try {
            CheckSession();
            handlePop();
            const response = await fetch('catalog/GetYearList/' + vehicle);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setYearList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    const LoadModelList = async () => {
        try {
            if (!year || !vehicle) {
                return;
            }
            handlePop();
            const data = [vehicle, year];
            CheckSession();
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch('catalog/GetModelList/', rqst);
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setModelList(lst);
        }
        catch (e) {
            console.log(e);
        }
        finally {
            handleClosePop();
        }
    }

    return (
        <>
            {UserInfo ?
                <>
                    <Container>
                        <Row className="mb-3 mt-3">
                            <Col sm={12} className="">
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col sm={2}>
                                                <Row>
                                                    <Col sm={12} className="text-left">
                                                        <h3 className="heading mt-2">{t('dealerhome.SHOP BY VEHICLE')}</h3>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col sm={6}>
                                                <Row className="border-right">
                                                    <Col sm={3}>
                                                        <Form.Select aria-label="Vehicle" value={vehicle} onChange={handleChange} name="vehicle" className="mt-2">
                                                            <option value={''}>{t('dealerhome.Select a vehicle')}</option>
                                                            {VehicleList && VehicleList.map(op => (
                                                                <option key={op.value} value={op.value}>{op.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Col>
                                                    <Col sm={2}>
                                                        <Form.Select aria-label="Year" value={year} onChange={handleChange} name="year" className="mt-2">
                                                            <option value={''}>{t('dealerhome.Year')}</option>
                                                            {YearList && YearList.map(op => (
                                                                <option key={op.value} value={op.value}>{op.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Select aria-label="Model" value={model} onChange={handleChange} name="model" className="mt-2">
                                                            <option value={''}>{t('dealerhome.Select a Model')}</option>
                                                            {ModelList && ModelList.map(op => (
                                                                <option key={op.value} value={op.value}>{op.label}</option>
                                                            ))}
                                                        </Form.Select>
                                                    </Col>

                                                    <Col sm={3} className="text-center">
                                                        <Button variant="primary" onClick={searchVehicle} disabled={!vehicle || !year || !model} className="btn-maintain">
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            {t('button.SHOP')}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col sm={4}>
                                                <Row>
                                                    <Col sm={8} className="text-left">
                                                        <h3 className="heading mt-2">{t('dealerhome.SHOP BY CATEGORY')}</h3>
                                                    </Col>

                                                    <Col sm={4}>
                                                        <Button variant="secondary" onClick={() => setCategoriesOpen(true)}>
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            {t('button.SHOP')}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>

                    <div className="banner">
                        <Container>
                            <Row>
                                <Col lg={6} className="banner-content">
                                    <h1>{t('dealerhome.PARTS &')}<br /> {t('dealerhome.ACCESSORIES')}</h1>

                                    <Button variant="primary" onClick={() => setCategoriesOpen(true)}>
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        {t('dealerhome.SHOP BY CATEGORY')}
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                    <Container className="checkout-container main-container dealer-section">
                        <Row className="mb-5">
                            <Col sm={6}>
                                <Card className="black-bg">
                                    <Card.Body>
                                        <Row>
                                            <Col sm={8} className="mb-4">
                                                <div className="svg-row dealer-card">
                                                    <div className="svg-holder">
                                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36.7 36.3" style={{ marginRight: 7 }}>
                                                            <g>
                                                                <path className="green" d="M10,1.2c-.9,0-1.6.7-1.6,1.6v24.5c0,.9.7,1.6,1.6,1.6h24.5c.9,0,1.6-.7,1.6-1.6V2.9c0-.9-.7-1.6-1.6-1.6H10ZM32.9,25.7H11.6V4.5h21.2v21.2Z" />
                                                                <path className="green" d="M15.4,16.7h5.2v5.2c0,.9.7,1.6,1.6,1.6.9,0,1.6-.7,1.6-1.6v-5.2h5.2c.9,0,1.6-.7,1.7-1.6s-.7-1.6-1.6-1.7c0,0,0,0,0,0h-5.2v-5.2c0-.9-.8-1.6-1.7-1.6-.9,0-1.6.7-1.6,1.6v5.2h-5.2c-.9,0-1.6.8-1.6,1.7,0,.9.7,1.6,1.6,1.6h0Z" />
                                                                <path className="green" d="M2.4,35.7h26.3c.9,0,1.6-.8,1.6-1.7,0-.9-.7-1.6-1.6-1.6H4.1V8.4c0-.9-.8-1.6-1.7-1.6-.9,0-1.6.7-1.6,1.6v25.7c0,.9.7,1.6,1.6,1.6Z" />
                                                            </g>
                                                        </svg>
                                                    </div>

                                                    <h5 className="green-text mb-0">{t('dealerhome.ITEM INQUIRY')}</h5>
                                                </div>
                                            </Col>
                                            <Col sm={4} className="mb-4">
                                                <p className="white underline text-right mb-0" onClick={() => handleItemModalShow(false)}>{t('dealerhome.Go to Form')}</p>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={9}>
                                                <FloatingLabel label={t("textfield.Item Number")} className="mb-4">
                                                    <Form.Control id="controlItemNum" type="text" placeholder="Item Number" value={itemNum} className={'form-control'} onChange={handleChange} name="itemNum" />
                                                </FloatingLabel>
                                            </Col>
                                            <Col sm={3}>
                                                <FloatingLabel label={t("textfield.Qty")} className="mb-4">
                                                    <Form.Control id="controlQty" type="text" placeholder="Qty" value={quantity} className={'form-control'} onChange={handleChange} name="quantity" />
                                                </FloatingLabel>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={{ offset: 6 }} xl={{ offset: 8 }} className="text-right mb-1">
                                                <Button variant="primary" className="" onClick={() => handleItemModalShow(true)} disabled={!itemNum || !quantity ? true : false}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    {t('button.SUBMIT')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={6}>
                                <Card>
                                    <Card.Body>
                                        <Row>
                                            <Col sm={8} className="mb-1">
                                                <div className="svg-row dealer-card">
                                                    <div className="svg-holder">
                                                        <svg version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="15px" y="15px" viewBox="0 0 50 50" xmlSpace="preserve">
                                                            <g stroke="none" strokeWidth="1">
                                                                <polygon className="st3" points="13.19,3.53 13.19,8.96 7.48,8.96 "></polygon>
                                                                <path className="st4" d="M-66.52,44.61"></path>
                                                                <path className="st3" d="M40.45,1.75H17.29c-0.82,0-1.48,0.66-1.48,1.48v6.77c0,0.82-0.66,1.48-1.48,1.48H7.46 
                                                                c-0.82,0-1.48,0.66-1.48,1.48v32.49c0,0.82,0.66,1.48,1.48,1.48h32.99c0.82,0,1.48-0.66,1.48-1.48V3.24 
                                                                C41.94,2.42,41.27,1.75,40.45,1.75z M18.17,38.88h-8c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h8 
                                                                c0.64,0,1.15,0.52,1.15,1.15C19.33,38.37,18.81,38.88,18.17,38.88z M26.34,30.47c0,0.64-0.52,1.15-1.15,1.15H10.18 
                                                                c-0.64,0-1.15-0.52-1.15-1.15v0c0-0.64,0.52-1.15,1.15-1.15h15.01C25.82,29.32,26.34,29.83,26.34,30.47L26.34,30.47z M37.58,24.37 
                                                                H10.18c-0.64,0-1.15-0.52-1.15-1.15s0.52-1.15,1.15-1.15h27.41c0.64,0,1.15,0.52,1.15,1.15S38.22,24.37,37.58,24.37z M37.58,17.11 
                                                                H10.18c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h27.41c0.64,0,1.15,0.52,1.15,1.15 
                                                                C38.74,16.59,38.22,17.11,37.58,17.11z M37.58,9.85h-17.5c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h17.5 
                                                                c0.64,0,1.15,0.52,1.15,1.15C38.74,9.33,38.22,9.85,37.58,9.85z"></path>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                    <h5 className="mb-0">{t('dealerhome.ORDERING')}</h5>
                                                </div>
                                            </Col>
                                            <Col sm={4} className="mb-4">
                                                <p className="underline text-right mb-0" onClick={() => navigate("/orderhistory")}>{t('dealerhome.Order History')}</p>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col sm={12}>
                                                <Table bordered>
                                                    <tbody>
                                                        <tr>
                                                            <td>{t('dealerhome.Open Orders')}</td>
                                                            <td className="text-center">{OpenOrderCount ? OpenOrderCount : 0}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('dealerhome.Back Orders')}</td>
                                                            <td className="red text-center">{BackOrderCount ? BackOrderCount : 0}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl={{ offset: 3 }} xxl={{ offset: 6 }} className="text-right mb-1">
                                                <Button variant="primary" className="" onClick={handleOrderClicked}>
                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                    </svg>
                                                    {t('button.NEW / IMPORT ORDER')}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/*<Row className="m-t-md" style={{ visibility: 'hidden' }}>*/}
                        {/*    <Col className="">{UserInfo.firstName} {UserInfo.lastName} {UserInfo.email}</Col>*/}
                        {/*    <Col className="checkout-title" onClick={LogoutDealerClick}>*/}
                        {/*        <Card.Title className="heading card-main-title active-heading clickable" role="heading">Log Out</Card.Title>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}

                    </Container>

                    <FooterDealer />
                </>

                :
                <></>
            }

            <ItemInquiry show={showItemModal} handleClose={handleItemModalClose} handleSelectedItems={handleSelectedItems} initialValues={ItemsToitemInquiry} orderType={1} autoSubmit={true} />

            <OrderSessionPopup show={showCartModal} handleShowCartClose={handleShowCartClose}></OrderSessionPopup>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>
        </>
    );
}